// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import { DATA_TAG_TEMPLATE, DATA_TAG_TEXT, DATA_TAG_REMOVE, DATA_TAG } from './constants.js';
import { toArray, normalizeText } from './utils.js';
import { isNativeFormControl, getChipValue, getControlFilterValue, isChipActive, setChipActive } from './controls.js';

export var _setupTags = function () {
  if (!this.tagsContainer) {
    return;
  }

  var template = this.wrapper.querySelector(DATA_TAG_TEMPLATE);
  if (!template) {
    return;
  }

  this.tagTemplate = template.cloneNode(true);
  template.remove();
};

export var _resolveTagLabelForFilter = function (field, raw, normalizedValue) {
  var control = this.filterControls.find(function (candidate) {
    var candidateField = normalizeText(candidate.getAttribute('data-pf-filter') || '');
    if (candidateField !== field) {
      return false;
    }

    var candidateValue = normalizeText(
      isNativeFormControl(candidate)
        ? getControlFilterValue(candidate)
        : getChipValue(candidate)
    );
    return candidateValue === normalizedValue;
  });

  if (!control) {
    return raw;
  }

  return control.getAttribute('data-pf-tag-label') || raw;
};

export var _buildTagTokens = function (state) {
  var tokens = [];

  Object.keys(state.filtersByField).forEach(
    function (field) {
      var seen = new Set();
      (state.filtersByField[field] || []).forEach(
        function (term) {
          var tokenKey = field + '|' + term.value;
          if (seen.has(tokenKey)) {
            return;
          }
          seen.add(tokenKey);

          var valueLabel = this._resolveTagLabelForFilter(field, term.raw, term.value);
          var label = this.tagFormat === 'value' ? valueLabel : field + ': ' + valueLabel;

          tokens.push({
            kind: 'filter',
            field: field,
            value: term.value,
            raw: term.raw,
            label: label,
          });
        }.bind(this)
      );
    }.bind(this)
  );

  state.searchGroups.forEach(function (group) {
    tokens.push({
      kind: 'search',
      index: group.id,
      raw: group.raw,
      label: 'Search: ' + group.raw,
    });
  });

  return tokens;
};

export var _renderTags = function (state) {
  if (!this.tagsContainer) {
    return;
  }

  var tokens = this._buildTagTokens(state);
  var fragment = document.createDocumentFragment();
  var self = this;

  tokens.forEach(function (token) {
    var tag = self.tagTemplate ? self.tagTemplate.cloneNode(true) : document.createElement('button');
    var textNode = tag.querySelector(DATA_TAG_TEXT);

    tag.setAttribute('data-pf-tag', '');
    tag.setAttribute('data-pf-tag-kind', token.kind);
    if (token.kind === 'filter') {
      tag.setAttribute('data-pf-tag-field', token.field);
      tag.setAttribute('data-pf-tag-value', token.value);
    } else {
      tag.setAttribute('data-pf-tag-search-index', String(token.index));
    }

    if (textNode) {
      textNode.textContent = token.label;
    } else {
      tag.textContent = token.label;
    }

    if (!tag.hasAttribute('type') && tag.tagName.toLowerCase() === 'button') {
      tag.setAttribute('type', 'button');
    }

    fragment.appendChild(tag);
  });

  this.tagsContainer.innerHTML = '';
  this.tagsContainer.appendChild(fragment);
  this.tagsContainer.hidden = tokens.length === 0;
};

export var _removeFilterToken = function (field, normalizedValue) {
  var changed = false;

  this.filterControls.forEach(function (control) {
    var controlField = normalizeText(control.getAttribute('data-pf-filter') || '');
    if (controlField !== field) {
      return;
    }

    if (!isNativeFormControl(control)) {
      var chipValue = normalizeText(getChipValue(control));
      if (chipValue === normalizedValue && isChipActive(control)) {
        setChipActive(control, false);
        changed = true;
      }
      return;
    }

    var tag = control.tagName.toLowerCase();
    var type = (control.type || '').toLowerCase();

    if (type === 'checkbox' || type === 'radio') {
      var controlValue = normalizeText(getControlFilterValue(control));
      if (controlValue === normalizedValue && control.checked) {
        control.checked = false;
        changed = true;
      }
      return;
    }

    if (tag === 'select') {
      if (control.multiple) {
        var localChange = false;
        toArray(control.options).forEach(function (opt) {
          if (normalizeText(opt.value) === normalizedValue && opt.selected) {
            opt.selected = false;
            localChange = true;
          }
        });
        if (localChange) {
          changed = true;
        }
        return;
      }

      if (normalizeText(control.value) === normalizedValue) {
        var wildcardOption = toArray(control.options).find(function (opt) {
          return opt.value === '*';
        });
        control.value = wildcardOption ? '*' : '';
        changed = true;
      }
      return;
    }

    if (normalizeText(control.value) === normalizedValue) {
      control.value = '';
      changed = true;
    }
  });

  return changed;
};

export var _removeSearchToken = function (index) {
  var control = this.searchControls[index];
  if (!control) {
    return false;
  }

  if (!control.value) {
    return false;
  }

  control.value = '';
  return true;
};

export var _handleTagClick = function (event) {
  var tagNode = event.target.closest(DATA_TAG);
  if (!tagNode || !this.tagsContainer || !this.tagsContainer.contains(tagNode)) {
    return;
  }

  var removeTrigger = tagNode.querySelector(DATA_TAG_REMOVE);
  if (removeTrigger && !event.target.closest(DATA_TAG_REMOVE)) {
    return;
  }

  event.preventDefault();

  var kind = tagNode.getAttribute('data-pf-tag-kind');
  var changed = false;

  if (kind === 'filter') {
    var field = normalizeText(tagNode.getAttribute('data-pf-tag-field') || '');
    var value = normalizeText(tagNode.getAttribute('data-pf-tag-value') || '');
    if (field && value) {
      changed = this._removeFilterToken(field, value);
    }
  } else if (kind === 'search') {
    var index = parseInt(tagNode.getAttribute('data-pf-tag-search-index'), 10);
    if (index >= 0) {
      changed = this._removeSearchToken(index);
    }
  }

  if (changed) {
    this.applyFilters({
      resetPage: true,
      reason: 'tag-remove',
    });
  }
};

